/**
 * NotificationBadge - Floating notification bell button (FAB)
 *
 * Matches Xamarin NotificationFAB.xaml exactly:
 * - BadgeView: BackgroundColor=Red, Margin=0, Padding=0, FontSize=9, FontAttributes=Bold,
 *   BadgePosition=TopRight, TextColor=White, Text="{Binding UnreadNotifications}"
 * - SvgCachedImage: Source=NotificationBell (blue circle 128x128 with white bell),
 *   HeightRequest=50, WidthRequest=50, Aspect=AspectFit
 * - TapGestureRecognizer: Command="{Binding OpenNotificationPopUpCommand}"
 *
 * Positioned in DashboardPage.xaml:
 * - Grid.RowSpan=4, HorizontalOptions=End, VerticalOptions=End
 * - HeightRequest=50, WidthRequest=50, Padding=5
 * - Margin: Phone='0,0,0,130' (above tab bar)
 */

import { IMAGE_CONSTANTS } from '@/constants';

interface NotificationBadgeProps {
  count: number;
  onPress: () => void;
}

export function NotificationBadge({ count, onPress }: NotificationBadgeProps) {
  return (
    /* Matches Xamarin: NotificationFAB HeightRequest=50, WidthRequest=50, Padding=5 */
    <button onClick={onPress} className="relative h-[50px] w-[50px]" aria-label="Notifications">
      {/* Matches Xamarin: SvgCachedImage NotificationBell HeightRequest=50 WidthRequest=50 AspectFit
          The SVG is a 128x128 blue circle (#1357A0) with white bell icon */}
      <img
        src={IMAGE_CONSTANTS.notificationBell}
        alt="Notifications"
        className="h-full w-full object-contain"
      />

      {/* Matches Xamarin: BadgeView BackgroundColor=Red, FontSize=9, Bold, BadgePosition=TopRight,
          TextColor=White, Text="{Binding UnreadNotifications}", Margin=0, Padding=0 */}
      {count > 0 && (
        <span className="absolute -right-0 -top-1.5 inline-flex items-center justify-center min-w-[20px] h-[20px] rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
